import Select from 'react-select';
import { SearchFieldStyles } from "../Searchfields/SearchFieldStyles";

const options = [
    { value: 0, label: "Em digitação" },
    { value: 1, label: "Aguardando análise" },
    { value: 2, label: "Revisar solicitação" },
    { value: 4, label: "Aprovada" },
    { value: 5, label: "Arquivada" }
];

const SituacaoSolicAcesso = ({ field, placeholder, name, id, disabled=false }) => {
    return (
        <Select 
            options={options} 
            {...field}
            styles={SearchFieldStyles}
            placeholder={placeholder}
            name={name}
            isDisabled={disabled}
            id={id}
        />
    )
}

export { SituacaoSolicAcesso, options as OpcoesSituacaoSolicAcesso }